module.exports = __webpack_public_path__ + "static/media/Bus Stop Mockup 2.4faa6025.png";